// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionStyle: 'style2',
    //suggestionStyle2MainContainerSelector: '#shopify-section-header',
    suggestionMobileStyle: 'style2',
  }
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  SearchInput.prototype.beforeBindEvents = function (id) {
    var id = this.id;
    if (id == Class.searchBox + '-0') {
      this.$element = removeThemeSearchEvent();
      this.instantSearchResult.$searchInputElement = this.$element;
    }
    recallThemeOnPageShowEvent();

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot redirect to search page when pressing enter
    if(jQ('.boost-pfs-search-box').length > 0) {
      jQ('.boost-pfs-search-box').wrap('<form action="/search" method="get" role="search"></form>');
    }
  }

  function removeThemeSearchEvent() {
    // Remove all events
    if (jQ('[name="q"]').length > 0) {
      var cloneSearchBar = jQ('[name="q"]').first().clone();
      jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
      jQ('[name="q"]').first().empty().append(cloneSearchBar);
      if (jQ('#Search').length > 0) {
        if (jQ('#Search').hasClass('Modal--fullScreen')) {
          jQ('#Search').attr("style", "height: 0px !important");
        }
        jQ('#Search .Search__Results').attr("style", "display: none !important");
      }

      // Rebuild click search icon event
      if (jQ('[data-action="toggle-search"]').length > 0) {
        jQ('[data-action="toggle-search"]').on('click', function () {
          setTimeout(function () {
            jQ('[name="q"]').first().focus();
          }, 500);
        })
      }
    }
    // disable page transition
    if (window.theme && window.theme.showPageTransition) {
      window.theme.showPageTransition = false;
    }
    return jQ('[name="q"]').first();
  }

  function recallThemeOnPageShowEvent() {
    // disable page transition
    var pageTransition = document.querySelector('.PageTransition');
    if (pageTransition) {
      pageTransition.style.visibility = 'visible';
      pageTransition.style.opacity = '0';
    }
    // refresh cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
})();

InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
  this.prepareSuggestionProductPriceData();
  var msrpcaArray = this.data.tags.filter((x)=> x.includes("msrppriceca:"));
  let compareAtPrice = null;
  let splitValue;
  let ca = window.location.href.includes("fr-ca") ||window.location.href.includes("en-ca");
  if(msrpcaArray?.length > 0 && ca){
      splitValue =  msrpcaArray[0].split(":");
      compareAtPrice = splitValue[1];
      let price = this?.data?.price_max_cad || 0;
      if(compareAtPrice){
        var result = '';
        if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
          if (compareAtPrice && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
          } else {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
          }
        }
      }

      let returnResult = result
      .replace(/{{regularPrice}}/g, Utils.formatMoney(price))
      .replace(/{{compareAtPrice}}/g, compareAtPrice ? Utils.formatMoney(compareAtPrice) : "");

      if(!compareAtPrice){
        console.log(returnResult, compareAtPrice );
        // Add no-red class while preserving existing classes
        returnResult = returnResult.replace(/<span(.*?)class="(.*?)"(.*?)>/i, '<span$1class="$2 no-red"$3>');
      }

      return returnResult;
  } else {
    let cmpAtPrice = Utils.formatMoney(this?.data?.compare_at_price_min)||false;
    if(cmpAtPrice){
      var result = '';
      if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (cmpAtPrice && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        } else {
          result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
      }
    }
    
    let returnResult = result
    .replace(/{{regularPrice}}/g, Utils.formatMoney(this.data.price_min))
    .replace(/{{compareAtPrice}}/g, this.data.compare_at_price_min ? Utils.formatMoney(this.data.compare_at_price_min) : "");
    
    if(!this.data.compare_at_price_min){
      console.log(returnResult, this.data.compare_at_price_min );
      // Add no-red class while preserving existing classes
      returnResult = returnResult.replace(/<span(.*?)class="(.*?)"(.*?)>/i, '<span$1class="$2 no-red"$3>');
    }

    return returnResult;
  }
}
